import React, { useCallback } from "react";
import { withTranslation } from 'react-i18next'
import { setNewMailingAddressProperty } from 'redux/actions';
import StreetAddress from 'shared/components/Address/StreetAddress'
import Apartment from 'shared/components/Address/Apartment'
import City from 'shared/components/Address/City'
import PostalCode from 'shared/components/Address/PostalCode'
import { useDispatch } from "react-redux"

import styles from './NewAddress.module.scss'
import { validateApartmentErrors, validateCityErrors, validatePostalCodeErrors, validateStreetAddressErrors } from "../../../../shared/helpers/validators";

const NEW_MAILING_ADDRESS = "newAddress.mailingAddress"
const NewMailingAddress = ({ t, i18n, setIsError, mailingAddressErrors, setMailingAddressErrors }) => {
  const dispatch = useDispatch();

  const validateStreetAddress = (name) => {
    const newMailingErrors = { ...mailingAddressErrors }
    newMailingErrors.streetAddress = validateStreetAddressErrors(name);
    setMailingAddressErrors(newMailingErrors);

  }

  const validateApartment = (name) => {
    const newMailingErrors = { ...mailingAddressErrors }
    newMailingErrors.apartment = validateApartmentErrors(name);
    setMailingAddressErrors(newMailingErrors);
  }

  const validateCity = (cityName) => {
    try {
      const newMailingErrors = { ...mailingAddressErrors }
      newMailingErrors.city = validateCityErrors(cityName);
      setMailingAddressErrors(newMailingErrors);
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePostalCode = (number) => {
    try {
      const newMailingErrors = { ...mailingAddressErrors }
      newMailingErrors.postalCode = validatePostalCodeErrors(number);
      setMailingAddressErrors(newMailingErrors);
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const handleChangeObjectPropertyAction = useCallback((fieldName, value) => {
    dispatch(setNewMailingAddressProperty(fieldName, value))
  }, [dispatch]);

  return (
    <div className={'container ' + styles['new-mailing-address-container']}>
      <div className="row">
        <div className="col-xs-12">
          <StreetAddress
            validateStreetAddress={validateStreetAddress}
            streetAddressError={mailingAddressErrors.streetAddress}
            streetAddressValid={mailingAddressErrors.streetAddress === '' ? '' : !mailingAddressErrors.streetAddress}
            setIsError={setIsError}
            reduxAppProperty={NEW_MAILING_ADDRESS}
            label={t('shared.mailing_address')}
            changeObjectPropertyAction={handleChangeObjectPropertyAction}
          />
          <Apartment
            validateApartment={validateApartment}
            apartmentError={mailingAddressErrors.apartment}
            apartmentValid={mailingAddressErrors.apartment === '' ? '' : !mailingAddressErrors.apartment}
            setIsError={setIsError}
            reduxAppProperty={NEW_MAILING_ADDRESS}
            changeObjectPropertyAction={handleChangeObjectPropertyAction}
          />
          <City
            validateCity={validateCity}
            validatePostalCode={validatePostalCode}
            cityError={mailingAddressErrors.city}
            cityValid={mailingAddressErrors.city === '' ? '' : !mailingAddressErrors.city}
            setIsError={setIsError}
            reduxAppProperty={NEW_MAILING_ADDRESS}
            changeObjectPropertyAction={handleChangeObjectPropertyAction}
          />
          <PostalCode
            validatePostalCode={validatePostalCode}
            postalCodeError={mailingAddressErrors.postalCode}
            postalCodeValid={mailingAddressErrors.postalCode === '' ? '' : !mailingAddressErrors.postalCode}
            setIsError={setIsError}
            reduxAppProperty={NEW_MAILING_ADDRESS}
            changeObjectPropertyAction={handleChangeObjectPropertyAction}
          />
        </div>
      </div>
    </div>

  )

}

export default withTranslation('common')(NewMailingAddress)